import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
    IEditProviderInfo,
    IOverrideProviderSupervisorPayload,
    IOverrideProviderSupervisorResponse,
    IPauseClientPayload,
    IProvider,
    IProviderCaseload,
} from "../types/providers.types";
import { IApiResponse } from "../../../utils/types/api-response";
import {
    overrideProvidersSupervisor,
    pauseProviderClient,
    updateProviderInfo,
} from "../services/providers.services";

export function useUpdateProviderInfo(providerId: string) {
    return useMutation<
        IApiResponse<IEditProviderInfo>,
        AxiosError<IApiResponse<IProvider>>,
        IEditProviderInfo
    >({
        mutationKey: ["update-provider-info"],
        mutationFn: (data: IEditProviderInfo) =>
            updateProviderInfo(providerId, data),
    });
}

export function usePauseProviderClient() {
    return useMutation<
        IApiResponse<IPauseClientPayload>,
        AxiosError<IApiResponse<IProviderCaseload>>,
        IPauseClientPayload
    >({
        mutationKey: ["pause-provider"],
        mutationFn: (data: IPauseClientPayload) => pauseProviderClient(data),
    });
}

export function useOverrideProvidersSupervisor(providerId: string) {
    return useMutation<
        IApiResponse<IOverrideProviderSupervisorResponse>,
        AxiosError<IApiResponse<IOverrideProviderSupervisorResponse>>,
        IOverrideProviderSupervisorPayload
    >({
        mutationKey: ["override-supervisor"],
        mutationFn: (payload: IOverrideProviderSupervisorPayload) =>
            overrideProvidersSupervisor(providerId, payload),
    });
}
